import { connect, MapStateToProps } from "react-redux";

import { BackgroundAttributeProps } from "@multiweb/reactComponents";
import { getAttributeInfoByName, getRecordById } from "@multiweb/reactCore/datasource";
import { IconCode } from "@multiweb/types/contracts";
import { IAppState } from "@multiweb/types/react";
import { CanRenderEmptyDecider, CanRenderEncryptedDecider, FrameAttributeSharedProps } from "../../types";
import { AttributeComponent, LiteListFrameGeneralAttributeComponent, LiteListFrameGeneralAttributeComponentProps, PlaceholderComponent } from "../LiteListFrameGeneralAttributeComponent";

export type LiteListFrameGeneralAttributeProps = FrameAttributeSharedProps & BackgroundAttributeProps & {
    /**
     * Rozhodovací funkce, která vrací true, pokud má komponenta
     * vyrenderovat placeholder pro zašifrovaný záznam.
     */
    canRenderEncrypted?: CanRenderEncryptedDecider;
    /**
     * Rozhodovací funkce, která vrací true, pokud má komponenta
     * vyrenderovat placeholder pro prázdný záznam.
     */
    canRenderEmpty?: CanRenderEmptyDecider;
    /** Komponenta placeholderu pro načítaný záznam. */
    SkeletonPlaceholder?: PlaceholderComponent;
    /** Komponenta placeholderu pro zašifrovaný záznam. */
    EncryptedPlaceholder?: PlaceholderComponent;
    /** Komponenta placeholderu pro prázdný záznam. */
    EmptyPlaceholder?: PlaceholderComponent;
    /** Komponenta pro zobrazení atributu. */
    AttributeComponent?: AttributeComponent;
    /** Určuje, jestli se má atribut vyrenderovat na řádku společně s ostatními atributy. */
    inline?: boolean;
    /** Pevná ikona, která se zobrazí spolu s hodnotou atributu*/
    iconCode?: IconCode;
};

type StateProps = Pick<
    LiteListFrameGeneralAttributeComponentProps,
    "record" | "dataSourceAttributeInfo"
>;

const mapStateToProps: MapStateToProps<StateProps, LiteListFrameGeneralAttributeProps, IAppState> = (
    state,
    { dataSourceKey, attributeName, recordId },
) => ({
    record: getRecordById(state, { dataSourceKey, recordId }),
    dataSourceAttributeInfo: getAttributeInfoByName(state, { dataSourceKey, attributeName }),
});

export const LiteListFrameGeneralAttribute = connect(mapStateToProps)(LiteListFrameGeneralAttributeComponent);
